import { render } from "./PageHeading.vue?vue&type=template&id=27728212"
import script from "./PageHeading.vue?vue&type=script&lang=ts"
export * from "./PageHeading.vue?vue&type=script&lang=ts"
script.render = render

export default script